<script setup lang="ts">
import { useI18n } from '@/i18n';
import { Block, Button, Heading, LayoutGap } from '@dabble/quillui';
import { useRouter } from 'vue-router';

const { t } = useI18n();
const router = useRouter();

function goToLogin() {
  router.push('/auth/login');
}
</script>

<template>
  <LayoutGap direction="row" align="center" vertical-align="center" fill class="not-found__page">
    <Block variant="canvas" class="not-found__block">
      <img src="/images/color-top.svg" alt="" class="not-found__color-top" role="presentation" />
      <Block variant="canvas" :padding="['medium', 'medium']">
        <LayoutGap direction="column" align="center" size="small" fill>
          <div class="not-found__logo-wrapper">
            <img src="/images/dabble-logo.svg" alt="Dabble" />
          </div>
          <LayoutGap direction="column" size="large" align="center" class="not-found__content">
            <Heading :level="1">{{ t('not_found_title') }}</Heading>
            <p class="not-found__message">{{ t('not_found_message') }}</p>
            <Button fill-width @click="goToLogin">{{ t('not_found_back_login') }}</Button>
          </LayoutGap>
        </LayoutGap>
      </Block>
    </Block>
  </LayoutGap>
</template>

<style lang="scss" scoped>
.not-found {
  &__page {
    min-height: 100vh;
    min-height: 100dvh;
    width: 100%;
    padding: space('medium');
    box-sizing: border-box;
  }

  &__block {
    width: min(100%, 28rem + space('huge') * 2);
    overflow: hidden;
    border-bottom-left-radius: borderRadius('large');
    border-bottom-right-radius: borderRadius('large');
  }

  &__color-top {
    display: block;
    width: 100%;
    height: auto;
    object-fit: cover;
    object-position: top center;
  }

  &__logo-wrapper {
    height: 64px;
    width: 100%;
    max-width: 160px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &__content {
    width: min(100%, 28rem);
    padding: space('small') space('huge') 0;
  }

  &__message {
    margin: 0;
    text-align: center;
    color: theme('color-text-secondary');
  }
}
</style>
